module.exports = __webpack_public_path__ + "img/a-propos-300x360.5fb8d6e5.jpg";